<template>
  <div class="home">
    <MainHeader />
    <Popup v-if="showPopup" />
    <Availability/>
    <About />
    <Accomodations />
    <Attractions />
    <Photos />
    <Reviews />
    <Contact />
    <lazy-component>
      <Location />
    </lazy-component>
    <lazy-component>
      <Footer />
    </lazy-component>
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import Popup from '@/components/Popup'
import Availability from '@/components/Availability'
import About from '@/components/About'
import Accomodations from '@/components/Accomodations'
import Attractions from '@/components/Attractions'
import Photos from '@/components/Photos'
import Reviews from '@/components/Reviews'
import Contact from '@/components/Contact'
import Location from '@/components/Location'
import Footer from '@/components/Footer'

export default {
  name: 'home',
  data () {
    return {
      showPopup: false
    }
  },
  components: {
    MainHeader,
    Popup,
    Availability,
    About,
    Accomodations,
    Attractions,
    Photos,
    Reviews,
    Contact,
    Location,
    Footer
  }
}
</script>
